var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.002,
    height: 19.462,
    viewBox: "0 0 17.002 19.462",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.a,.b{stroke:#53b5e0;stroke-miterlimit:10;}.b{fill:#53b5e0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.765 183.013) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M119.422,168.5l-4.227-4.24-4.227,4.24h2.667v6.565h3.119V168.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M126.98,182.887v-6.565h-3.119v6.565h-2.667l4.227,4.24,4.227-4.24Z",
    transform: "translate(-4.088 -4.822)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.897168d50c1bb5c7e98f4b634f022729.svg";
export { ForwardRef as ReactComponent };